import React from 'react';
import Box from '@mui/material/Box';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import {
  CorporateTitleLabels,
  getCorporateTitles,
} from '../../../helpers/approvalValidatorCommon';

export interface AcceptanceMatrixDialogProps {
  approvalResults: any;
}

export const AcceptanceMatrix = ({
  approvalResults,
}: AcceptanceMatrixDialogProps) => {
  return (
    <Box>
      <Table sx={{ whiteSpace: 'pre-line', padding: 2 }} size="small">
        <TableHead>
          <TableRow>
            <TableCell style={{ fontWeight: 'bold' }}>Syy</TableCell>
            <TableCell style={{ fontWeight: 'bold' }}>Arvo</TableCell>
            {Object.values(CorporateTitleLabels).map(
              (corporateTitleLabel, index) => (
                <TableCell
                  key={corporateTitleLabel + index}
                  style={{ fontWeight: 'bold' }}
                >
                  {corporateTitleLabel}
                </TableCell>
              ),
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {approvalResults?.map((results: any) => {
            return (
              <TableRow key={results.reasonLabel}>
                <TableCell>{results.reasonLabel}</TableCell>
                <TableCell>{results.displayValue}</TableCell>
                {getCorporateTitles().map((title, index) => {
                  return (
                    <TableCell key={index + '-' + title}>
                      <Typography
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          minWidth: '100px',
                        }}
                      >
                        <span>
                          {results.requirements[title].label}
                        </span>
                        {results.requirements[title].isRequired ? (
                          <ErrorIcon
                            color="error"
                            sx={{ fontSize: '1.1rem' }}
                          />
                        ) : (
                          <Box sx={{ width: '1.1rem' }} />
                        )}
                      </Typography>
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Box>
  );
};

export default AcceptanceMatrix;
